import SegmentService, { EventGroup, EventTypeInteraction } from "module/analytics/service/SegmentService"
import { TrackingProps } from "module/analytics/types"

import { Button, Table, TableCaption, TableProps } from "@chakra-ui/react"
import { useCallback } from "react"

interface PerpTableProps extends TableProps {
    onLoadMore?: () => void
    isLoadingMore?: boolean
    trackingProps?: TrackingProps
}

export const PerpTable = ({ onLoadMore, isLoadingMore, trackingProps, children, ...perp }: PerpTableProps) => {
    // NOTE: Track load more
    const handleLoadMore = useCallback(() => {
        onLoadMore?.()
        if (trackingProps) {
            SegmentService.track(EventGroup.INTERACTION, {
                eventType: EventTypeInteraction.BUTTON_CLICKED,
                ...trackingProps,
            })
        }
    }, [onLoadMore, trackingProps])

    return (
        <Table size="sm" variant="simple" {...perp}>
            <>
                {children}
                {onLoadMore && (
                    <TableCaption>
                        <Button onClick={handleLoadMore} isLoading={isLoadingMore}>
                            Load More
                        </Button>
                    </TableCaption>
                )}
            </>
        </Table>
    )
}
